import React from 'react';
import Login from './Login';

const AuthPage: React.FC = () => (
  <div className="auth-page">
    <div className="auth-card">
      <div className="auth-brand">
        <div className="auth-logo">
          <span className="devrain-mark devrain-mark-large" aria-hidden="true"><span /><span /></span>
        </div>
        <div>
          <h1>DevRain Time</h1>
          <p>Team time tracking</p>
        </div>
      </div>
      <Login />
    </div>
  </div>
);

export default AuthPage;
